import React, { useState, useContext, useEffect } from "react";
import "./divideBill.scss";
import { useHistory } from "react-router-dom";

// material ui
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Backdrop from "@mui/material/Backdrop";
import { grey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { PieChart } from 'react-minimal-pie-chart';
// handleTotalPerson
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import { useSelector, useDispatch } from 'react-redux';
import AddIcon from "@mui/icons-material/Add";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import IconButton from '@mui/material/IconButton';
import InvoiceProcessing from "../../Assets/images/invoiceProcessing.svg";


function DivideBill(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { subTotal, paidAmount, store, setPartialType, splitBillAmount, setSplitBillAmount, totalPerson, setTotalPerson, personWillPay, setPersonWillPay } = props;
  const [open, setOpen] = React.useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [divideBillContent, setDivideBillContent] = useState([])
  var greenObj = { title: 'Two', value: 1, color: '#60B200' }
  var grayObj = { title: 'One', value: 1, color: '#D9D9D9' }
  var remainAmount = subTotal - paidAmount;

  const handleConfirm = () => {
    appDispatch({
      type: "setDivideBill",
      divideBill: false,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: false,
    });
    appDispatch({
      type: "setSplitBill",
      splitBill: true,
    });
    localStorage.removeItem("divideBill")
    localStorage.removeItem("splitBillOptions")
    localStorage.setItem("splitBill", Boolean(true))
    localStorage.setItem('divideColor',JSON.stringify(divideBillContent))
    let amount = ((remainAmount / totalPerson) * personWillPay).toFixed(3)
    setSplitBillAmount(Number(amount))
    setPartialType('ratio')
  }


  const handleChangeSplit = () => {
    appDispatch({
      type: "setDivideBill",
      divideBill: false,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: true,
    });
    localStorage.removeItem("divideBill")
    localStorage.setItem("splitBillOptions", true)
    localStorage.removeItem("divideColor")
    setSplitBillAmount(0)
    setPartialType('')
  }

  useEffect(() => {
    if(splitBillAmount <= 0){
      setTotalPerson(2)
      setPersonWillPay(1)
    setDivideBillContent([grayObj, greenObj])

    }
    else{
    let localData = JSON.parse(localStorage.getItem("divideColor"))
    if(localData && localData.length) {
      setDivideBillContent(localData)
    }
    }
 
  }, [])
  

  const handleNoOFPerson = (type) => {
    if (type === "inc" && totalPerson < 10) {
      setTotalPerson(totalPerson + 1)
      let dbc = divideBillContent
      setDivideBillContent([grayObj, ...dbc])
    } else if (type === "dec") {
      if (totalPerson > 2) {
        if (totalPerson - 1 < personWillPay) {
          setPersonWillPay(totalPerson - 1)
        }
        setTotalPerson(totalPerson - 1)
        let dbc = divideBillContent
        dbc.shift()
        setDivideBillContent(dbc)
      }

    }
  }

  const handlePersonWillPay = (type) => {
    if (type === "inc" && personWillPay < totalPerson) {
      setPersonWillPay(personWillPay + 1)
      let dbc = divideBillContent
      if (dbc[0].color === '#D9D9D9') {
        dbc.shift()
      }
      setDivideBillContent([...dbc, greenObj])
    } else if (type === "dec") {
      if (personWillPay > 1) {
        setPersonWillPay(personWillPay - 1)
        let dbc = divideBillContent
        dbc.unshift(grayObj)
        dbc.pop()
        setDivideBillContent(dbc)

      }
    }
  }


  return (
    <>


      <div id="mySidenav" className={`divideBill ${appState.langValue == "ar" ? "divideBillArabic" : " "
        }`}>
        {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}
        <div className="container-fluid content px-4 pb-3 mt-4">
          <h1 className={` ${appState.langValue === "ar" ? "text-right familyGraphikArabic800 " : " familyPoppins600"
            }`}
          > {t("invoice.Divide-the-bill-equally")}</h1>
          {/* <div className="d-flex justify-content-center py-3">     <img src={InvoiceProcessing} /></div> */}
          <div className="pieChart d-flex justify-content-center">
            <PieChart
              animation
              animationDuration={500}
              animationEasing="ease-out"
              center={[50, 50]}
              data={divideBillContent}
              labelPosition={50}
              lengthAngle={360}
              lineWidth={15}
              paddingAngle={5}
              radius={40}
              startAngle={92.5}
              viewBoxSize={[100, 100]}
            />
          </div>


          <div className="py-3">
            <div className="row align-items-center">
              <div className="col-6">
                <span className={` ${appState.langValue === "ar" ? "text-right d-flex familyGraphikArabic800 " : " familyPoppins"
                  }`} >{t("invoice.Number-of-people-at-the-table")}</span>
              </div>
              <div className="col-6 d-flex justify-content-end">

                <div
                  className={` d-flex  IncDecBtnMain   ${appState.langValue == "ar" ? "flex-row-reverse justify-content-start" : "justify-content-end"
                    } `}
                >
              
                  <IconButton onClick={() => handleNoOFPerson("dec")} className="decrementBtn" variant="contained">
                    <RemoveRoundedIcon className="px-1 " />
                  </IconButton>

                  <div className="IncDecValue d-flex px-2 justify-content-center align-items-center">
                    <p className="px-2 mb-0 familyPoppins700">{totalPerson}</p>
                  </div>

                  <IconButton
                    onClick={() => handleNoOFPerson("inc")}
                    className={false ? `btnDisabled` : `incrementBtn`}
                    variant="contained"
                  >
                    <AddIcon className="px-1 " />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className="row align-items-center mt-3">
              <div className="col-6">
                <span className={` ${appState.langValue === "ar" ? "text-right d-flex familyGraphikArabic800 " : " familyPoppins"
                  }`} >{t("invoice.You-will-pay-for")}</span>

              </div>
              <div className="col-6 d-flex justify-content-end">
                <div
                  className={` d-flex  IncDecBtnMain   ${appState.langValue == "ar" ? "flex-row-reverse justify-content-start" : "justify-content-end"
                    } `}
                >
                  <IconButton onClick={() => handlePersonWillPay("dec")} className="decrementBtn" variant="contained">
                    <RemoveRoundedIcon className="px-1 " />
                  </IconButton>

                  <div className="IncDecValue d-flex justify-content-center px-2 align-items-center">
                    <p className="px-2 mb-0 familyPoppins700">{personWillPay}</p>
                  </div>

                  <IconButton
                    onClick={() => handlePersonWillPay("inc")}
                    className={false ? `btnDisabled` : `incrementBtn`}
                    variant="contained"


                  >
                    <AddIcon className="px-1 " />
                  </IconButton>
                </div>
              </div>
            </div>
          </div>


          <div className="d-flex  align-items-center py-3 w-100 justify-content-between ">
            <h5 className={` totalAmount mb-0  ${appState.langValue === "ar" ? "text-right d-flex" : "familyPoppins600"
              }`}>{t("invoice.You-are-paying")}:</h5>
            <h5 className={` totalAmount mb-0 ${appState.langValue === "ar" ? "text-right" : "familyPoppins600"
              }`}>
              <span className="px-1">{((remainAmount / totalPerson) * personWillPay).toFixed(3)} </span>
              <span className="px-1">{t(`${store?.currency}`)}</span>  </h5>
          </div>

         
          <div className="bottomBtn">
            <Button
              onClick={handleConfirm}
              disabled={remainAmount == 0  }
              className={` py-3 px-4  mt-3 justify-content-center ${
                appState.langValue === "ar" ? " familyGraphikArabic600" : ""
              } ${remainAmount == 0 ? `disabledBtn` : `confirmBtn`}`}
            >
              {" "}
              <span className="text-capitalize">
                {t("invoice.Confirm")}
              </span>{" "}
            </Button>
            <Button
              onClick={handleChangeSplit}
              className={` py-3 px-4 mt-3 deletebtn justify-content-center ${
                appState.langValue === "ar" ? " familyGraphikArabic600" : ""
              }`}
            >
              {" "}
              <span className="text-capitalize">
                {t("invoice.Delete-Split")}
              </span>{" "}
            </Button>
          </div>


        </div>
      </div>
    </>


  );
}



export default withTranslation()(DivideBill);